import {
  uploadReportFile, getBtcReportList, deleteBtcReport, addBeefBulletin, updateBtcReport
} from '@/api/btcreport'

const btcreport = {
  state: {
    total: 0,
    rows: []
  },
  mutations: {
    SET_TOTAL: (state, total) => {
      state.total = total
    },
    SET_ROWS: (state, rows) => {
      state.rows = rows
    }
    // SET_ROW: (state, row) => {
    //   state.row = row
    // },
    // SET_ASSEMBLYLIST: (state, list) => {
    //   state.assemblyList = list
    // },
    // SET_QUANTITY: (state, quantity) => {
    //   state.quantity = quantity
    // },
    // SET_EXPORTERS: (state, exporters) => {
    //   state.exporters = exporters
    // },
    // SET_REVIEWS: (state, reviews) => {
    //   state.reviews = reviews
    // },
    // SET_CHATTOTAL: (state, total) => {
    //   state.chatTotal = total
    // },
    // SET_CHATROWS: (state, rows) => {
    //   state.chatRows = rows
    // }
  },
  actions: {
    GetBtcReportList({ commit }, params) {
      return new Promise((resolve, reject) => {
        getBtcReportList(params).then(response => {
          commit('SET_TOTAL', response.Data.Total)
          commit('SET_ROWS', response.Data.Rows)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    UploadReportFile({ commit }, params) {
      return new Promise((resolve, reject) => {
        uploadReportFile(params).then(response => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    DeleteBtcReport({ commit }, params) {
      return new Promise((resolve, reject) => {
        deleteBtcReport(params).then(response => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    AddBeefBulletin({ commit }, params) {
      return new Promise((resolve, reject) => {
        addBeefBulletin(params).then(response => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    UpdateBtcReport({ commit }, params) {
      return new Promise((resolve, reject) => {
        updateBtcReport(params).then((response) => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}
export default btcreport



// WEBPACK FOOTER //
// ./src/store/modules/report.js